import { useEffect, useState } from 'react';
import type { Overview } from '@trivio/contracts';
import { ApiProblemError, getOverview } from '../../lib/api-client';

export interface UseOverviewResult {
  overview: Overview | null;
  loading: boolean;
  error: string | null;
}

function extractProblemMessage(err: unknown, fallback: string): string {
  return err instanceof ApiProblemError ? (err.problem.detail ?? err.problem.title) : fallback;
}

/** `GET /v1/overview` (TTP-282) fetch for the `/` home screen — same shape as `useUsage.ts`/`useCosts.ts`, no params (always the current calendar month, server-side). */
export function useOverview(apiKey: string | null): UseOverviewResult {
  const [overview, setOverview] = useState<Overview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!apiKey) {
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    getOverview(apiKey)
      .then((result) => {
        if (!cancelled) setOverview(result);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(extractProblemMessage(err, 'Não foi possível carregar a visão geral.'));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [apiKey]);

  return { overview, loading, error };
}
